export enum PortalType {
  Normal = 'Normal',
  OnBoarding = 'OnBoarding',
  Broker = 'Broker',
  Provider = 'Provider'
}

export enum Admin {
  Pha = 'PHA',
  Medscheme = 'MEDSCHEME'
}


export const BasePaths: Record<PortalType, string> = {
  [PortalType.Normal]: '/enterprise-management',
  [PortalType.OnBoarding]: '/onboarding',
  [PortalType.Broker]: '/broker',
  [PortalType.Provider]: '/provider'
};

export const PathSegments = {
  Application: 'applications',
  ImportApplication: 'application-import',
  GroupApplication: 'group-application',
  IndividualApplication: 'individual-application',
  ReviewApplication: 'review-application',
  AddPerson: 'add-person'
};

export function buildRoute(portal: PortalType, relativePath: string): string {
  return `${BasePaths[portal]}/${relativePath}`;
}
